import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import SmartStaysLogo from '../components/SmartStaysLogo';
import API_URL from '../config';
import { validateRequiredFields, clearFieldInvalid } from '../utils/formValidation';
import './Activate.css';
import '../publicTheme.css';

function ResetPassword() {
  const { t } = useTranslation();
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    document.title = 'SmartStays - Wachtwoord wijzigen';
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateRequiredFields(e.target) || !password || !confirmPassword) {
      setMessage(t('resetPassword.fillAll'));
      setMessageType('error');
      return;
    }

    if (password !== confirmPassword) {
      setMessage(t('resetPassword.passwordsNoMatch'));
      setMessageType('error');
      return;
    }

    if (password.length < 6) {
      setMessage(t('resetPassword.passwordMinLength'));
      setMessageType('error');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API_URL}/api/reset-password`, { token, password });
      setMessage(response.data.message);
      setMessageType('success');
      setDone(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setMessage(err.response?.data?.error || t('resetPassword.failed'));
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="activate-container">
      <div className="activate-card">
        <div className="activate-header">
          <h1><SmartStaysLogo /></h1>
          <p>{t('resetPassword.subtitle')}</p>
        </div>

        {!done && (
          <form onSubmit={handleSubmit} noValidate onInput={clearFieldInvalid}>
            <div className="form-group">
              <label>{t('resetPassword.newPassword')}</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder={t('resetPassword.passwordPlaceholder')}
              />
            </div>

            <div className="form-group">
              <label>{t('resetPassword.confirmPassword')}</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                placeholder="••••••••"
              />
            </div>

            {message && (
              <div className={`message ${messageType}`}>
                {message}
              </div>
            )}

            <button type="submit" disabled={loading}>
              {loading ? t('resetPassword.loading') : t('resetPassword.submit')}
            </button>
          </form>
        )}

        {done && (
          <>
            {message && (
              <div className={`message ${messageType}`}>
                {message}
              </div>
            )}
            <p className="reset-back-link">
              <Link to="/login">{t('resetPassword.backToLogin')}</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
